var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- ko with: props --> <ul class="nfd-switcher"data-bind="foreach: items"role="navigation"><!-- ko let: { isItemActive: $parent.isItemActive($index()) } --> <li class="nfd-switcher-item nfd-switcher-item-strange"data-bind="\n			click: $parent.onItemClick.bind(null, $index()),\n			css: {\n				\'nfd-switcher-item-active\': isItemActive,\n				\'nfd-switcher-item-hovered\': !isItemActive,\n			},\n		"> <div data-bind="html: htmlContent"></div> </li><!-- /ko --> </ul> <!-- /ko -->';
}
return __p;
};
